import React, { useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useConnectionProvider } from "../../../../../Providers/Vendor/Connections";
import { Link, useNavigate } from "react-router-dom";
import CustomTable from "../../../../../Components/Table";
import Back from "../../../../../Components/Back";
import { stringAvatar } from "../../../../../Utils/avatar";
import { Avatar } from "@mui/material";

const headCells = [
  { label: "Client" },
  { label: "Status" },
  // { label: "Number Of Consultants" },
  { label: "" },
];

export default function Client({ setCard }) {
  const {
    clientsWithCount,
    clients,
    fetchClientsWithConsultantCount,
    fetchClients,
  } = useConnectionProvider();

  const navigate = useNavigate()

  useEffect(() => {
    // fetchClientsWithConsultantCount();
    fetchClients();
  }, []);

  const CustomRow = ({ row }) => {
    return (
      <TableRow hover tabIndex={-1} key={row.id}>
        <TableCell component="th" scope="row">
          <Link target="_blank" to={`/client/profile/${row.id}`}>
            <span className="flex flex-row items-center">
              <Avatar
                {...stringAvatar(
                  row.companyName
                    ? row.companyName
                    : row.firstName
                      ? `${row.firstName} ${row.lastName}`
                      : row.email
                )}
                className="mr-2.5"
                size="large"
                src={row?.profilePhoto}
              />
              {row?.companyName || row?.firstName + " " + row?.lastName}
            </span>
          </Link>
        </TableCell>
        <TableCell align="left">Current</TableCell>
        {/* <TableCell align="left">{row.consultantCount}</TableCell> */}
        <TableCell align="left">
          <Link target="_blank" to={`/client/profile/` + row.id}>
            <span className="hover:cursor-pointer text-blue-400">
              View Details
            </span>
          </Link>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <>
      <Back onClick={() => {
        navigate("/dashboard")
      }} />
      <CustomTable
        title="Clients"
        headCells={headCells}
        rows={clients.filter((client) => client.status === "Current")}
        CustomRow={CustomRow}
      />
    </>
  );
}
